import { WrapLgMarginBottom } from 'App/global-style';
import styled from 'styled-components';

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > * {
    margin-top: 32px;
  }

  > *:first-child {
    margin-top: 0px;
  }
`;

export const AlertContainer = styled(WrapLgMarginBottom)`
  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;
